module.exports = __webpack_public_path__ + "static/media/medai_chat.0e252191.png";